<div>
	<div class="modal-header">
		<h4 class="modal-title">Réinitialiser le mot de passe pour l'utilisateur {{userName}}</h4>
		<button type="button" class="close" aria-label="Close" (click)="cancelDialog()"><span aria-hidden="true">&times;</span></button>
	</div>

	<div class="modal-body">
		<p>Etes-vous sûre de vouloir réinitialiser le mot de passe de l'utilisateur ?</p>
        <p>Pour le réinitialiser, cliquez sur le bouton "Réinitialiser".</p>
        <p>Pour annuler l'action, cliquez sur le bouton "Annuler".</p>
    </div>

    <div class="modal-footer">
		<button type="button" class="btn btn-light" (click)="cancelDialog()">Annuler</button>
		<button type="submit" class="btn btn-primary" [disabled]="!enableAction" (click)="save()">{{buttonText}}</button>
	</div>
</div>